<!--
 * @Author: zhechuan.Wang
 * @Date: 2023-11-22 14:59:42
 * @LastEditors: zhechuan.Wang
 * @LastEditTime: 2024-04-07 09:44:07
 * @Description: file content
 * @FilePath: \gfmis-card-ppt\src\views\homePage.vue
-->
<!--
 * @Author: zhechuan.Wang
 * @Date: 2023-11-16 11:27:04
 * @LastEditors: zhechuan.Wang
 * @LastEditTime: 2023-12-07 16:14:32
 * @Description: 补贴政策首页
 * @FilePath: \gfmis-card-ppt\src\views\homePage.vue
-->
<template>
  <div class="pageRoot">
    <div class="content">
      <div class="searchBlock">
        <div class="left">
          <label>行政区划：</label>
          <el-select ref="selectTree" v-model="mofDivName" size="small" placeholder="请选择" class="selectRoot">
            <template slot="prefix">
              {{ mofDivName }}
            </template>
            <el-option v-for="item in treeList" :key="item.value" :label="item.label" :value="item.value"
              style="display: none">
            </el-option>
            <el-tree :data="treeList" :default-expanded-keys="defaultOpenTrees" node-key="id" :props="defaultProps"
              :expand-on-click-node="false" :render-content="renderContent" @node-click="handleNodeClick"></el-tree>
          </el-select>
          <label class="selectLabel">年份：</label>
          <el-dropdown trigger="click" @command="selectYear">
            <span class="el-dropdown-link">
              {{ yearValue }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="item.value" v-for="item in yearList" :key="item.value">{{ item.label
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-checkbox v-model="isValid" @change="checkboxChange" style="margin-left: 15px">含失效项目</el-checkbox>
        </div>
        <div class="right">
          <el-input size="medium" placeholder="请输入内容" suffix-icon="el-icon-search" v-model="searchParam"
            @change="searchChange">
          </el-input>
          <el-pagination class="pagination paginationTop" background small :current-page="pageConfig.currentPage"
            :pager-count="pageConfig.pagerCount" :page-sizes="pageConfig.pageSizes" :page-size="pageConfig.pageSize"
            :layout="pageConfig.layouts" :total="pageConfig.total" @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
          </el-pagination>
          <div class="totalPage">, {{ pageConfig.pages }}页</div>
        </div>
      </div>
      <div class="carList" id="carList" v-loading="loading">
        <div class="card" v-for="item, index in tableData" :key="index">
          <img class="failure" v-if="item.isValid == 2" src="@/assets/images/failure.png" />
          <el-row class="card-head" :gutter="20">
            <el-col :span="8"><span class="searText" :style="{color: item.isValid == 2 ? '#666666' : ''}">{{ item.spName }}</span></el-col>
            <el-col :span="8">主管部门：<span class="searText">{{ item.manageDepName }}</span></el-col>
            <el-col class="searText" :span="8">公示时间：<span class="searText">{{ item.puDate }}</span></el-col>
          </el-row>
          <div class="card-content">
            <div class="card-content-row">
              <div class="card-content-row-col">
                行政区划: <span class="mofDivCodeName"><span class="searText">{{ item.mofDivName }}</span></span>
              </div>
              <div class="card-content-row-col">
                项目类别: <span class="spTypeName"><span class="searText">{{ item.spTypeName }}</span></span>
              </div>
              <div class="card-content-row-col">
                项目级次: <span class="spTypeName"><span class="searText">{{ item.spLevelName }}</span></span>
              </div>
              <div class="card-content-row-col">
                已发放人次: <span class="perCount"><span class="searText">{{ item.perCount }}</span></span>
              </div>
              <div class="card-content-row-col">
                已发放金额(万元): <span class="searText">{{ item.amtCountMoney }}</span>
              </div>
            </div>
            <div class="card-describe">
              <ul class="card-describe-left">
                <li><span class="point">·</span>补贴政策：<span class="searText">{{ item.policyName }}</span></li>
                <li>
                  <span class="point">·</span>补贴范围(对象)：
                  <el-tooltip :disabled="isShowObjInfoTooltip" :visible-arrow="false" :content="item.objInfo"
                    placement="top-start" effect="light">
                    <span :ref="'objInfoRef' + index" @mousemove="onMouseOver('objInfoRef' + index, 1)"
                      style="margin-left: -5px"><span class="searText">{{ item.objInfo }}</span></span>
                  </el-tooltip>
                </li>
                <li ref="liRef">
                  <span class="point">·</span>补贴标准：
                  <el-tooltip :disabled="isShowStaInfoTooltip" :visible-arrow="false" :content="item.staInfo"
                    placement="top-start" effect="light">
                    <span :ref="'staInfoRef' + index" @mousemove="onMouseOver('staInfoRef' + index, 2)"
                      style="margin-left: -5px"><span class="searText">{{ item.staInfo }}</span></span>
                  </el-tooltip>
                </li>
                <li>
                  <span class="point">·</span>发放单位：
                  <el-tooltip :disabled="isShowGrantObjTooltip" :visible-arrow="false" :content="item.grantObj"
                    placement="top-start" effect="light">
                    <span :ref="'grantObjRef' + index" @mousemove="onMouseOver('grantObjRef' + index, 3)"
                      style="margin-left: -5px"><span class="searText">{{ item.grantObj }}</span></span>
                  </el-tooltip>
                </li>
                <li><span class="point">·</span>咨询电话：<span class="searText">{{ item.conTel }}</span></li>
              </ul>
              <div class="card-describe-right">
                <el-button class="card-describe-right-btn" :type="item.isBtnDisable ? 'info' : 'primary'" size="small"
                  @click="handleReadFile(item)" :disabled="item.isBtnDisable">政策文件</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="noneData" v-if="!tableData.length">暂无数据</div>
      </div>
      <div class="page_blcok">
        <el-pagination class="pagination" background small :current-page="pageConfig.currentPage"
          :pager-count="pageConfig.pagerCount" :page-sizes="pageConfig.pageSizes" :page-size="pageConfig.pageSize"
          :layout="pageConfig.layouts" :total="pageConfig.total" @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
        <div class="totalPage">, {{ pageConfig.pages }}页</div>
      </div>
    </div>
    <div class="footer" v-loading="footerLoading">
      <div class="footer-card">
        <img class="bgImg" src="@/assets/images/user_bg.png" />
        <div class="footer-card-info">
          <p>{{ totalCountObj.year }}年</p>
          <p class="secon_row">{{ totalCountObj.perCount }}</p>
          <p>已发放人次</p>
        </div>
      </div>
      <div class="footer-card">
        <img class="bgImg" src="@/assets/images/money_bg.png" />
        <div class="footer-card-info">
          <p>{{ totalCountObj.year }}年</p>
          <p class="secon_row">{{ totalCountObj.amtCount }}</p>
          <p>已发放金额(万元)</p>
        </div>
      </div>
      <div class="footer-card">
        <img class="bgImg" src="@/assets/images/project_bg.png" />
        <div class="footer-card-info">
          <p>{{ totalCountObj.year }}年</p>
          <p class="secon_row">{{ totalCountObj.proCount }}个</p>
          <p>已发放项目</p>
        </div>
      </div>
    </div>
    <component ref="dialogRef" v-if="dialogInfo.component && dialogInfo.showDialog" v-bind="dialogInfo"
      :showDialog.sync="dialogInfo.showDialog" :is="dialogInfo.component" />
  </div>
</template>

<script>
import fileListDialog from './subsidize/components/dialog/fileListDialog.vue'
import Api from '@/api/cardProject'
import commonJs from './mixins/common'
import XEUtils from 'xe-utils';

export default {
  name: 'HomePage',
  mixins: [commonJs],
  data() {
    return {
      Api,
      isShowReadFile: false,
      footerLoading: false,
      isDisabledNode: true, // 是否禁止点击数节点
      isShowObjInfoTooltip: true, // 是否禁用补贴对象提示
      isShowStaInfoTooltip: true, // 是否禁用补贴标准提示
      isShowGrantObjTooltip: true, // 是否禁用发放单位提示
      searchParam: '',
      cityValue: '海南省',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      cityList: [
        {
          value: '海南省',
          label: '海南省'
        },
        {
          value: '海口市',
          label: '海口市'
        },
        {
          value: '三亚市',
          label: '三亚市'
        },
      ],
      yearList: [
        {
          value: '全部',
          label: '全部'
        },
        {
          value: '2025',
          label: '2025',
        },
        {
          value: '2024',
          label: '2024',
        },
        {
          value: '2023',
          label: '2023',
        },
        {
          value: '2022',
          label: '2022',
        },
        {
          value: '2021',
          label: '2021',
        },
        {
          value: '2020',
          label: '2020',
        },
        {
          value: '2019',
          label: '2019',
        },
      ],
      dialogInfo: {
        component: null,
        showDialog: false,
      },
      mofDivCode: '',
      mofDivName: '',
      depCode: '',
      agencyCode: '',
      treeList: [],
      defaultOpenTrees: [],
      totalCountObj: {}, // 表尾统计
      isValid: false, // 是否含已失效项目
    };
  },
  async mounted() {
    const { mof_div_code, dep_code, agency_code } = this.$route.query
    this.mofDivCode = mof_div_code;
    this.depCode = dep_code;
    this.agencyCode = agency_code;
    // await this.getTreeData()
    const { mofDivCode, mofDivName } = await this.getTreeData()
    if (mofDivCode && mofDivName) {
      this.mofDivCode = mofDivCode
      this.mofDivName = mofDivName
      this.$store.commit('setCurrentNode', { mofDivCode: this.mofDivCode, mofDivName: this.mofDivName })
    }
    this.getList()
  },
  methods: {
    onMouseOver(refName, state) {
      const parentWidth = this.$refs.liRef[0].offsetWidth
      const contentWidth = this.$refs[refName][0].offsetWidth
      // 判断是否开启 tooltip 功能，如果溢出显示省略号，则子元素的宽度势必短于父元素的宽度
      // 减去92是左侧标题的宽度
      if (state == 1) {
        this.isShowObjInfoTooltip = !(contentWidth > parentWidth - 92)
      } else if (state == 2) {
        this.isShowStaInfoTooltip = !(contentWidth > parentWidth - 92)
      } else if (state == 3) {
        this.isShowGrantObjTooltip = !(contentWidth > parentWidth - 92)
      }

    },
    // 表查询
    async searchChange() {
      this.pageConfig.currentPage = 1
      await this.getList()
      this.searchKeywords('.searText')
    },
    // 树节点回调
    handleNodeClick(data, node, nodeObj) {
      this.isParentNode = data.children?.length > 0;
      if (data.isDisabeld) {
        return
      }
      this.mofDivCode = data.value;
      this.mofDivName = data.label;
      if (this.mofDivCode && this.mofDivName) {
        this.$store.commit('setCurrentNode', { mofDivCode: this.mofDivCode, mofDivName: this.mofDivName })
      }
      this.$refs.selectTree.blur();
      this.pageConfig.currentPage = 1
      this.getList()
    },
    selectYear(value) {
      this.yearValue = value;
      this.pageConfig.currentPage = 1
      this.getList()
    },
    // 渲染树节点是否可点击
    renderContent(h, { node, data, store }) {
      if (!this.isDisabledNode) {
        return <span>{node.label}</span>;
      }
      if (data.isDisabeld) {
        return <span style="color: #606266; cursor: context-menu">{node.label}</span>;
      } else {
        return <span style="color: #409EFF; cursor: pointer">{node.label}</span>;
      }
    },
    checkboxChange() {
      this.getList();
    },
    // 设置请求参数与方法
    getListBefore({ currentPage = this.pageConfig.currentPage, pageSize = this.pageConfig.pageSize }) {
      this.getTotalCount();
      return {
        method: this.Api.getList,
        args: {
          currentPage,
          pageSize,
          model: {
            mofDivCode: this.mofDivCode,
            fiscalYear: isNaN(this.yearValue) ? '' : this.yearValue,
            dep: this.depCode,
            agencyCode: this.agencyCode,
            isFlag: true,
            isValid: this.isValid ? 2 : 1
          }
        },
      };
    },
    getListAfter() {
      this.tableData?.forEach(v => {
        v.isBtnDisable = !v.cardAttachments?.length
        // 格式化以万元为单位并保留两位小数点
        const amtCount = Number(v.amtCount || 0)
        v.amtCountMoney = amtCount > 0 ? v.amtCount / 10000 : amtCount;
        v.amtCountMoney = XEUtils.commafy(v.amtCountMoney, { digits: 2 })
      })
    },
    async getTotalCount() {
      this.footerLoading = true;
      const { data: res } = await Api.getCurrent({
        deptCode: this.depCode,
        mofDivCode: this.mofDivCode == '460000000' ? '' : this.mofDivCode,
        agencyCode: this.agencyCode,
        year: isNaN(this.yearValue) ? '' : this.yearValue
      })['finally'](() => this.footerLoading = false)
      if (res.code !== 0 && res.code !== 200) {
        return this.$message.error(res.msg)
      }
      if (res.data) {
        this.totalCountObj = res.data
        let amtCount = Number(this.totalCountObj.amtCount || 0)
        amtCount = amtCount > 0 ? this.totalCountObj.amtCount / 10000 : amtCount;
        this.totalCountObj.amtCount = XEUtils.commafy(amtCount, { digits: 2 })
      }
    },
    handleReadFile(item) {
      this.dialogInfo = {
        component: fileListDialog,
        showDialog: true,
        formResult: item.cardAttachments || []
      };
    },
    selectCity(value) {
      this.cityValue = value;
    },
  },
};
</script>
<style scoped lang="scss">
.pageRoot {
  // flex: 1;
  padding: 0 10%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  background-color: white;


}

.content {
  min-height: 55vh;
  max-height: 2140px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: auto;

  .searchBlock {
    display: flex;
    justify-content: space-between;
    padding: 5px 10px;
    border-bottom: 1px solid #dfdddd;

    .selectLabel {
      margin-left: 10px;
    }

    .selectRoot {
      min-width: 100px;
      text-align: start;

      ::v-deep .el-input--small {
        font-size: 16px;
      }

      ::v-deep .el-input__prefix {
        position: relative;
        box-sizing: border-box;
        border: none;
        padding: 0 20px;
        height: 40px !important;
        line-height: 40px !important;
        color: #409EFF;
        left: 0;
        visibility: hidden;
      }

      ::v-deep .el-input__inner {
        border: none;
        color: #409EFF;
        position: absolute;
        padding: 0;
        height: 40px !important;
        line-height: 40px !important;
      }
    }

    .el-dropdown-link {
      font-size: 16px;
      cursor: pointer;
      color: #409EFF;
    }

    .el-icon-arrow-down {
      font-size: 12px;
    }

    .citySelect {
      margin-right: 20px !important;
    }

    .right {
      display: flex;
    }

    .paginationTop {
      margin: auto 0;
      margin-left: 5px;
    }
  }

  .carList {
    flex: 1;
    overflow-y: auto;
  }

  .totalPage {
    min-width: 40px;
    font-size: 13px;
    font-weight: 400;
    color: #606266;
    margin-top: 8px;
    margin-left: -10px;
  }

  .page_blcok {
    display: flex;
    justify-content: end;

    .totalPage {
      margin-top: 14px;
    }
  }

  // .carList:hover {
  //   overflow-y: auto;
  // }

  ::-webkit-scrollbar {
    width: 5px;
    background-color: white;
  }

  .carList::-webkit-scrollbar-thumb {
    width: 5px;
    background-color: #5396ff;
    border-radius: 6px;
  }

  // .carList::-webkit-scrollbar-thumb:hover {
  //   width: 5px;
  //   background-color: #5396ff;
  //   border-radius: 6px;
  // }

  .card {
    margin-top: 10px;
    border: 2px solid #ecf2f8;
    position: relative;

    .failure {
      width: 60px;
      height: 60px;
      position: absolute;
      right: 5px;
      top: 5px;
      transform: rotate(35deg);
      z-index: 9;
    }

    &-head {
      color: #003399;
      font-size: 16px;
      margin: 0 !important;
      padding: 5px 10px;
      background-color: #f0f5fa;
    }

    &-content {
      padding: 5px 10px 0 10px;

      &-row {
        display: flex;
        justify-content: space-between;

        &-col {
          width: 20%;
          overflow: hidden;
          white-space: nowrap;
          // text-overflow: ellipsis;
        }
      }
    }



    .mofDivCodeName {
      color: #2D89D9
    }

    .spTypeName {
      color: #008000
    }

    .perCount {
      color: #0000FF
    }

    &-describe {
      display: flex;
      justify-content: space-between;

      &-left {
        flex: 1;
        margin: 5px 0;
        padding-left: 0;
        overflow-x: hidden;

        li {
          width: 100%;
          margin: 3px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          list-style: none;

          .point {
            font-size: 16px;
            font-weight: bold;
            margin-right: 5px;
          }
        }

        .subsidlzeTitle {
          color: #0000FF;
          // cursor: pointer;
        }

        // .subsidlzeTitle:hover {
        //   border-bottom: 1px solid #0000FF;
        // }
      }

      &-right {
        width: 100px;
        position: relative;

        &-btn {
          font-size: 14px;
          position: absolute;
          bottom: 15px;
        }
      }
    }
  }

  .pagination {
    min-height: 30px;
    text-align: right;
    margin-top: 10px;
  }
}

.noneData {
  text-align: center;
  color: gray;
  margin-top: 100px;
}

.footer {
  width: 100%;
  height: 140px;
  display: flex;
  justify-content: space-between;
  color: white;
  margin-top: 20px;
  margin-bottom: 10px;

  &-card {
    width: 270px;
    display: flex;
    justify-content: space-between;
    position: relative;

    .bgImg {
      width: 270px;
      height: 100%;
      z-index: 1;
      position: absolute;
    }

    &-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0px 15px;
      z-index: 2;
      font-size: 22px;

      p {
        margin: 5px 0;
      }

      .secon_row {
        font-weight: bold;
      }
    }
  }
}
</style>